/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../resources/datatypes';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "team_api": {
        "nested": {
          "RetrieveTeamMemberInvitationRequest": {
            "fields": {
              "invitationId": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "RetrieveTeamMemberInvitationResponse": {
            "fields": {
              "teamMemberInvitation": {
                "type": ".squareup.team_api.TeamMemberInvitation",
                "id": 1,
                "rule": "optional"
              },
              "errors": {
                "type": ".squareup.connect.v2.resources.Error",
                "id": 2,
                "rule": "repeated"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.team_api?.nested?.RetrieveTeamMemberInvitationRequest && !$root.nested?.squareup?.nested?.team_api?.nested?.RetrieveTeamMemberInvitationResponse) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc Represents a retrieve request for a `TeamMemberInvitation` object.
 * --
 *
 * SOURCE RetrieveTeamMemberInvitationRequest @ squareup/team_api/endpoints/retrieve-team-member-invitation.proto at 21:1
 */
export const RetrieveTeamMemberInvitationRequest = $root.lookupType('squareup.team_api.RetrieveTeamMemberInvitationRequest');
fixType(RetrieveTeamMemberInvitationRequest, {
  invitationId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(RetrieveTeamMemberInvitationRequest);
/**
 * --
 * @desc Represents a response from the retrieve request containing a `TeamMemberInvitation` object or
 * error messages.
 * --
 *
 * SOURCE RetrieveTeamMemberInvitationResponse @ squareup/team_api/endpoints/retrieve-team-member-invitation.proto at 30:1
 */
export const RetrieveTeamMemberInvitationResponse = $root.lookupType('squareup.team_api.RetrieveTeamMemberInvitationResponse');
fixType(RetrieveTeamMemberInvitationResponse);
Builder.createAndAttachToType(RetrieveTeamMemberInvitationResponse);